import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { homeLocal } from "./pages/home/local.home"; 
const resources = {
  en: {
    
    translation: {
      "Welcome to React": "Welcome to React and react-i18next",
      home:homeLocal.en, 
      menu:{
        en:"Anglais",
        fr:"Français",
        "home": "Home",
        "about": "About",
        "catalog":"Catalog",
        "contact": "Contact",
        "ressource": "Ressource",
        "blog": "Blog",
        "calendar": "Calendar",
        "forum": "Forum",
        "maketPlace": "Market Place",
        "profil": "Profile",
        "trainning": "Training",
        language:"Langue (En)",
  },
    }
  },
  fr: {   
    
    translation: {
      home:homeLocal.fr,  
      "Welcome to React": "Bienvenue à React et react-i18next",
      menu: {
        en:"English",
        fr:"French",
        "home": "Accueil",
        "about": "Présentation",
        "contact": "Contact",
        "catalog":"Annuaires",
        "ressource": "Ressources",
        "blog": "Blog",
        "calendar": "Calendrier",
        "forum": "Forum",
        "maketPlace": "Place du marché",
        "profil": "Profil",
        "trainning": "Entraînement",
        language:"Language (Fr)", 
    }
,
    }
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

  export default i18n;